export const ResumeEducationCustomFields = (): string => {
  return '';
};
